export const messageMixin = {
	methods: {
		jumpToTragetMessage(opts) {
			const { messageId } = opts;

			// this.scrollToMessage(`${messageId}`);
		}
	}
};